module.exports = __webpack_public_path__ + "img/201610.59788ad2.jpg";